"use strict";

exports.__esModule = true;
exports.DefaultPageSize = DefaultPageSize;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _Translator = require("../../../Core/Translator");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function DefaultPageSize(props) {
  var setDefaultPageSize = props.setDefaultPageSize,
    defaultPageSize = props.defaultPageSize,
    _props$pageSizes = props.pageSizes,
    pageSizes = _props$pageSizes === void 0 ? [5, 25, 100, 500, 1000] : _props$pageSizes;
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("DataTableFields.pagination.pageSize.label", "Default Page Size"),
    helperText: translate("DataTableFields.pagination.pageSize.helperText", "Select the default page size or auto to fit the rows to the space available.")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.HTML_SELECT
  }, /*#__PURE__*/_react["default"].createElement("select", {
    "data-testid": "DefaultPageSize.selector",
    value: defaultPageSize,
    onChange: function onChange(e) {
      setDefaultPageSize(Number(e.target.value) || "auto");
    }
  }, /*#__PURE__*/_react["default"].createElement("option", {
    key: "auto",
    value: "auto",
    "data-testid": "DefaultPageSize.option.auto"
  }, translate("DataTable.Labels.AutoRows", "Auto")), pageSizes.map(function (size) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: size,
      value: size,
      "data-testid": "DefaultPageSize.option." + size
    }, size);
  }))));
}